import script from "./ClientReattachDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientReattachDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ClientReattachDropdown.vue?vue&type=style&index=0&id=97c11898&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97c11898"]])

export default __exports__